The public web URL of the posted job ad on SEEK.
